import React, {useState, useEffect} from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { 
    Button,
    TextField,
    Checkbox,
    Grid,
    IconButton
} from "@mui/material";
import { styled } from '@mui/material/styles';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'
import { enqueueSnackbar } from 'notistack';

import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import BodyMain from "../../components/util/BodyMain";
import { constants } from '../../util';


import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AddArtist from "./addArtist";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AddSong from "./addSong";
import Message from "../../components/message/message";
import { deleteAlbumArtist, deleteAlbumSong, getAlbumArtistList, getAlbumList, getAlbumSongList, saveAlbum, uploadAlbumImage } from "../../services/albumService";
import { showWaiting, showTermsOfUse } from "../../store/slices/configSlice";

import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { esES, enUS } from '@mui/x-data-grid/locales';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';

import downloadFile from '../../components/util/Download'
import AudioPlayer from "../../components/util/audioPlayer";
import Confirmation from "../../components/message/confirmation";




const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '100%',
    overflow: 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: '100%', // Cambiado de 1 a 100%
    opacity: 0, // Usamos opacidad 0 en lugar de tamaño mínimo
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}





const AddAlbum = () => {
    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    const navigate = useNavigate();
    const location = useLocation();
    const { action, selectedAlbumId, isAlbum } = location.state || {action:'add', selectedAlbumId:-1, isAlbum:true};

    const dispatch = useDispatch();
    const {language, openSignup, deviceType} = useSelector(state => state.configuration);
    const {userLogged} = useSelector(state => state.userLogged);
    const [openAddArtist, setOpenAddArtist] = useState(false);
    const [openAddSong, setOpenAddSong] = useState(false);
    const [selectedAlbumArtist, setSelectedAlbumArtist] = useState(null);
    const [listArtist, setListArtist] = useState([]);
    const [listSong, setListSong] = useState([]);
    const [checked, setChecked] = useState(false);
    const [albumId, setAlbumId] = useState(null);
    const [albumCoverImage, setAlbumCoverImage] = useState('/assets/img/generic/no-image.jpeg');
    const [isCreated, setIsCreated] = useState(false);
    const [showMessageSave, setShowMessageSave] = useState(false);
    const [readOnly, setReadOnly] = useState(true);
    const [showConfirmDeleteArtist, setShowConfirmDeleteArtist] = useState(false);
    const [showConfirmDeleteSong, setShowConfirmDeleteSong] = useState(false);
    const [selectedItemDelete, setSelectedItemDelete] = useState(-1); 
    const [numSongs, setNumSongs] = useState(0); 
    const [maxPercentageAllowed, setMaxPercentageAllowed] = useState(0); 
    

    const sch = (yup) => yup.object({
        title: isAlbum ? yup.string().required().min(3).max(40) : yup.string().max(40),
        launchingDate: yup.date().transform((value, originalValue) => {
                return originalValue === '' ? null : value;
            }).required(),
        creator: yup.string().required().min(3).max(40),
        producer: yup.string().required().min(3).max(40),
    });
    const schema = useYupSchema(sch);


    const handleClick_UpdateArtist = (artistId) =>{
        setSelectedAlbumArtist(artistId);
        setOpenAddArtist(true);
    }

    
    const handleClick_DeleteArtist = (artistId) =>{
        setShowConfirmDeleteArtist(true);
        setSelectedItemDelete(artistId)
    }


    const handleClick_DeleteSong = (songId) =>{
        setShowConfirmDeleteSong(true);
        setSelectedItemDelete(songId)
    }


    const handleClick_Go = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    }


    const columnsArtist = [
        {
            field: 'albumArtistId',
            description: '',
            headerName: '',
            type: 'string',
            width: 80,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div style={{width:'100%', height:'100%',
                            // display:'flex',
                            display: action==='view' ? 'none' : 'flex',
                            justifyContent:'center',
                            alignContent:'center'
                            }}
                    >
                        <div>
                            <IconButton 
                                color="primary"
                                onClick={(e) => handleClick_UpdateArtist(params.value)} // Función para editar
                                aria-label="Editar"
                                // sx={{alignSelf:'center', placeSelf:'center'}}

                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton 
                                color="primary"
                                onClick={(e) => handleClick_DeleteArtist(params.value)} // Función para editar
                                aria-label="Editar"
                                // sx={{alignSelf:'center', placeSelf:'center'}}

                            >
                                <DeleteForeverRoundedIcon fontSize="small" />
                            </IconButton>
                        </div>
                    </div>
                );
            }
        },
        {
            field: 'name',
            description: t("addAlbumGeneral.artist"),
            headerName: t("addAlbumGeneral.artist"),
            type: 'string',
            width: 180,
            headerAlign: 'left',
        },
        {
            field: 'artistType',
            description: t("addAlbumGeneral.artistType"),
            headerName: t("addAlbumGeneral.artistType"),
            type: 'string',
            width: 160,
            headerAlign: 'left',
        },
        {
            field: 'prctParticipation',
            description: t("addAlbumGeneral.prctParticipation"),
            headerName: t("addAlbumGeneral.prctParticipation"),
            type: 'int',
            width: 160,
            headerAlign: 'middle',
            renderCell: (params) => {
                return (<div>{`${params.row.prctParticipation}%`}</div>)
            }
        },
        {
            field: 'urlSpotify',
            description: 'Spotify',
            headerName: 'Spotify',
            type: 'string',
            width: 80,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div>
                        <IconButton 
                            color="primary"
                            onClick={(e) => handleClick_Go(params?.value)}
                        >
                            <div style={{fontSize:'10px'}}>
                            <img
                                src="/assets/img/logo/spotity-c.png"
                                alt="icon"
                                style={{ width: 15, height: 15 }}
                            /><br />
                            Spotify
                            </div>
                        </IconButton>
                    </div>
                )
            }
        },
        {
            field: 'urlApple',
            description: 'Apple Music',
            headerName: 'Apple Music',
            type: 'string',
            width: 80,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div>
                        <IconButton 
                            color="primary"
                            onClick={(e) => handleClick_Go(params?.value)}
                        >
                            <div style={{fontSize:'10px'}}>
                            <img
                                src="/assets/img/logo/apple-c.png"
                                alt="icon"
                                style={{ width: 15, height: 15 }}
                            /><br />
                            Apple Music
                            </div>
                        </IconButton>
                    </div>
                )
            }
        },
        {
            field: 'urlTiktok',
            description: 'Tiktok',
            headerName: 'Tiktok',
            type: 'string',
            width: 80,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div>
                        <IconButton 
                            color="primary"
                            onClick={(e) => handleClick_Go(params?.value)}
                        >
                            <div style={{fontSize:'10px'}}>
                            <img
                                src="/assets/img/logo/tiktok-c.png"
                                alt="icon"
                                style={{ width: 15, height: 15 }}
                            /><br />
                            Tiktok
                            </div>
                        </IconButton>
                    </div>
                )
            }
        },
        {
            field: 'urlYoutube',
            description: 'Youtube',
            headerName: 'Youtube',
            type: 'string',
            width: 80,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div>
                        <IconButton 
                            color="primary"
                            onClick={(e) => handleClick_Go(params?.value)}
                        >
                            <div style={{fontSize:'10px'}}>
                            <img
                                src="/assets/img/logo/youtube.png"
                                alt="icon"
                                style={{ width: 15, height: 15 }}
                            /><br />
                            Youtube
                            </div>
                        </IconButton>
                    </div>
                )
            }
        },
        {
            field: 'urlInstagram',
            description: 'Instagram',
            headerName: 'Instagram',
            type: 'string',
            width: 80,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div>
                        <IconButton 
                            color="primary"
                            onClick={(e) => handleClick_Go(params?.value)}
                        >
                            <div style={{fontSize:'10px'}}>
                            <img
                                src="/assets/img/logo/instagram_color.png"
                                alt="icon"
                                style={{ width: 15, height: 15 }}
                            /><br />
                            Instagram
                            </div>
                        </IconButton>
                    </div>
                )
            }
        },
        {
            field: 'urlFacebook',
            description: 'Facebook',
            headerName: 'Facebook',
            type: 'string',
            width: 80,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div>
                        <IconButton 
                            color="primary"
                            onClick={(e) => handleClick_Go(params?.value)}
                        >
                            <div style={{fontSize:'10px'}}>
                            <img
                                src="/assets/img/logo/facebook_c.png"
                                alt="icon"
                                style={{ width: 15, height: 15 }}
                            /><br />
                            Facebook
                            </div>
                        </IconButton>
                    </div>
                )
            }
        },
    ];



    const columnsSongs = [
        {
            field: 'albumSongId',
            description: '',
            headerName: '',
            type: 'string',
            width: 80,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div style={{width:'100%', height:'100%',
                            // display:'flex',
                            display: action==='view' ? 'none' : 'flex',
                            justifyContent:'center',
                            alignContent:'center'
                            }}
                    >
                        <div>
                            <IconButton 
                                color="primary"
                                onClick={(e) => handleClick_DeleteSong(params.value)} // Función para editar
                                aria-label="Editar"
                                // sx={{alignSelf:'center', placeSelf:'center'}}
                            >
                                <DeleteForeverRoundedIcon fontSize="small" />
                            </IconButton>
                        </div>
                    </div>
                );
            }
        },
        {
            field: 'name',
            description: t("addAlbumGeneral.songName"),
            headerName: t("addAlbumGeneral.songName"),
            type: 'string',
            width: 180,
            headerAlign: 'left',
        },
        {
            field: 'lyricsFile',
            description: t("addAlbumGeneral.lyrics"),
            headerName: t("addAlbumGeneral.lyrics"),
            type: 'string',
            width: 160,
            headerAlign: 'left',
            renderCell: (params) => {
                return (
                    <div style={{width:'100%', height:'100%',
                            display:'flex',
                            justifyContent:'center',
                            alignContent:'center'
                            }}
                    >
                        <div>
                            {
                                params.value !== ''
                                ?
                                    <IconButton 
                                        color="primary"
                                        onClick={(e) => downloadFile(params.value, `${params.row.name}.txt`)}
                                        aria-label="Editar"
                                    >
                                        <TextSnippetOutlinedIcon fontSize="large" />
                                    </IconButton>
                                : null
                            }
                        </div>
                    </div>
                )
            }
        },
        {
            field: 'audioFile',
            description: t("addAlbumGeneral.audio"),
            headerName: t("addAlbumGeneral.audio"),
            type: 'string',
            width: 420,
            headerAlign: 'left',
            renderCell: (params) => {
                return(
                    <div style={{width:'100%', height:'100%',
                            display:'flex',
                            justifyContent:'center',
                            alignContent:'center'
                            }}
                    >
                        <div>
                            <AudioPlayer audioUrl={params.value} filenameToDownload={`${params.row.name}.wav`} />
                        </div>
                    </div>
                )
            }
        },
    ];



    const handleChange_Terms = (event) => {
        setChecked(event.target.checked);
    };


    const handleClickTerms = () => {
        // dispatch(showTermsOfUse(true));
        window.open('/termsofuse', '_blank', 'noopener,noreferrer');
    }


    const { control, register, handleSubmit, reset, setFocus, getValues, setValue, formState: { errors: errors } } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            launchingDate: '',
            title: '',
            creator: '',
            producer: '',
        }
    });

    const handleReturnBack = () => {
        if (userLogged.role==='Artista')
            navigate('/songs')
        else
            navigate('/approvalsongs')
    }


    const handleClick_AddArtist = () => {
        setSelectedAlbumArtist(null);
        setOpenAddArtist(true);
    }


    const handleClose_AddArtist = (obj) => {
        setOpenAddArtist(false);
        setSelectedAlbumArtist(null);

        getAlbumArtistList(selectedAlbumId, '-1')
            .then((rsp2) => {
                setListArtist(rsp2.metadata)
            });
        calculateMaxPercentageAllowed();
    }

    const handleAddSong = (obj) => {
        setOpenAddSong(false);
        if (obj!==null){
            setListSong(prevSongs => [...(Array.isArray(prevSongs) ? prevSongs : []), obj]);
            setNumSongs(numSongs+1);
        }
    }

    const calculateMaxPercentageAllowed = () => {
        const sumPorcentages = arreglo.reduce((acumulador, artista) => {
            return acumulador + artista.porcentaje;
        }, 0);

        console.log(sumPorcentages);
        
        setMaxPercentageAllowed(100-sumPorcentages)
    }



    const [activeStep, setActiveStep] = React.useState(0);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const [value2, setValue2] = React.useState('one');

    const handleChange = (event, newValue) => {
        setValue2(newValue);
    };
  


    const [fileName, setFileName] = useState("");

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
        setFileName(file.name);
        }
    };

    const onSubmit = (data) => {
        dispatch(showWaiting(true));

        saveAlbum(
            albumId,
            data.title, 
            data.launchingDate, 
            data.creator, 
            data.producer,
            isAlbum
        ).then(
            (rsp) => {
                setTimeout(() => {
                    if (rsp.code === '00'){
                        setAlbumId(rsp.metadata?.albumId?.toString())

                        getAlbumArtistList(rsp.metadata?.albumId?.toString())
                            .then((rsp2) => {
                                setListArtist(rsp2.metadata)
                            });
                        calculateMaxPercentageAllowed();

                        if (action==='addalbum' || action==='addsong')
                            setShowMessageSave(true);
                        else
                            enqueueSnackbar(
                                language==='es' 
                                    ? 'Los cambios se guardaron exitosamente' 
                                    : 'Changes were saved successfully'
                                , { variant: 'success', persist: false });

                        setReadOnly(false);
                        dispatch(showWaiting(false));

                        navigate('/addalbum', 
                            {
                                state: {
                                    action: 'edit',
                                    selectedAlbumId: rsp.metadata?.albumId?.toString(),
                                    isAlbum: isAlbum
                                }
                            }
                        );
                    }
                    else{
                        enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                        dispatch(showWaiting(false));
                    }
                        
                }, 1000);
            }
        )
        .catch(err => {
            enqueueSnackbar('+++++++', { variant: 'error', persist: false });
            dispatch(showWaiting(false));
        });
        
    }


    const uploadCoverFile = async (event) => {
            dispatch(showWaiting(true));
            const files = event.target.files;
            if (files?.length > 0){
                const file = files[0];
                
                // Validación de tamaño (20MB máximo)
                const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB en bytes
                
                if (file.size > MAX_FILE_SIZE) {
                    event.target.value = '';
                    dispatch(showWaiting(false));
                    enqueueSnackbar(
                        language === 'es' 
                            ? 'El archivo es demasiado grande. Tamaño máximo permitido: 20MB'
                            : 'File is too large. Maximum allowed size: 20MB',
                        { variant: 'error', persist: false }
                    );
                    return;
                }


                await fileToImage(file)
                    .then( img => {
                        if ( (img.width === 1500 && img.height === 1500)
                                || (img.width === 3000 && img.height === 3000) )
                            uploadAlbumImage(files[0], albumId)
                                .then( (rsp) => {
                                    setTimeout(() => {
                                        if (rsp.code==='00')
                                            setAlbumCoverImage(rsp.metadata?.urlImage);
                                        else
                                            enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                                        
                                        dispatch(showWaiting(false));
                                        event.target.value = '';
                                    }, 1000);
                                })
                                .catch( error => {
                                    event.target.value = '';
                                    dispatch(showWaiting(false));
                                })
                        else{
                            event.target.value = '';
                            dispatch(showWaiting(false));
                            enqueueSnackbar(
                                language === 'es'
                                    ? 'El archivo no es válido, debe ser JPG o PNG con resolución de 1500x1500 o 3000x3000 pixeles'
                                    : 'File is not valid, must be JPG or PNG, with this resolution: 1500x1500 o 3000x3000 pixeles' 
                                , { variant: 'error', persist: false });
                        }
                    })
                    .catch( error => {
                        event.target.value = '';
                        dispatch(showWaiting(false));
                    })
            }
            else
            {
                event.target.value = '';
                dispatch(showWaiting(false));
            }
        }


    
    const handleDeleteArtist = (responseDelete) => {
        if (responseDelete){
            dispatch(showWaiting(true));

            deleteAlbumArtist(
                albumId.toString(),
                selectedItemDelete,
            ).then(
                (rsp) => {
                    setTimeout(() => {
                        getAlbumArtistList(selectedAlbumId)
                            .then((rsp) => {
                                setListArtist(rsp.metadata)
                            });
                        calculateMaxPercentageAllowed();
                
                        enqueueSnackbar(rsp.message, 
                            { variant: rsp.code==='00' ? 'success' : 'error', persist: false });
                        dispatch(showWaiting(false));
                    }, 1000);
                }
            );
        }
    }


    const handleDeleteSong = (responseDelete) => {
        if (responseDelete){
            dispatch(showWaiting(true));

            deleteAlbumSong(
                albumId.toString(),
                selectedItemDelete,
            ).then(
                (rsp) => {
                    setTimeout(() => {
                        getAlbumSongList(selectedAlbumId)
                            .then((rsp) => {
                                setListSong(rsp.metadata);
                                setNumSongs(rsp.metadata.length);
                            });

                        enqueueSnackbar(rsp.message, 
                            { variant: rsp.code==='00' ? 'success' : 'error', persist: false });
                        dispatch(showWaiting(false));
                    }, 1000);
                }
            );
        }
    }
    


    const loadData = (selectedAlbumId) => {
        dispatch(showWaiting(true));

        getAlbumList(selectedAlbumId)
            .then((rsp) => {
                reset(rsp.metadata);
                setAlbumCoverImage(rsp.metadata?.albumPhoto);

                getAlbumArtistList(selectedAlbumId, -1)
                    .then((rsp) => {
                        setListArtist(rsp.metadata)
                    });
                calculateMaxPercentageAllowed();


                getAlbumSongList(selectedAlbumId)
                    .then((rsp) => {
                        setListSong(rsp.metadata);
                        setNumSongs(rsp.metadata.length);
                    });

                dispatch(showWaiting(false));
            })
            .catch((error) => {
                dispatch(showWaiting(false));
            });
    };


    useEffect(()=>{
        switch(action){
            case "view": 
                setAlbumId(selectedAlbumId);
                loadData(selectedAlbumId);
                setReadOnly(true);
                break;
            case "edit": 
                setAlbumId(selectedAlbumId);
                loadData(selectedAlbumId);
                setReadOnly(false);
                setChecked(true);
                break;
            case "addalbum":
                setAlbumId(-1);
                setReadOnly(true);
                setChecked(false);
                break;
            case "addsong": 
                setAlbumId(-1);
                setReadOnly(true);
                setChecked(false);
                break;
            default: 
                navigate('/index'); 
                break;
        }
    }, [])



    function fileToImage(file) {
        return new Promise((resolve, reject) => {
            if (!file || !file.type.match('image.*')) {
                reject(new Error("El archivo no es una imagen válida."));
            return;
            }

            // 1. Crear un objeto URL temporal para el File
            const imageUrl = URL.createObjectURL(file);

            // 2. Crear un objeto Image y asignarle la URL
            const img = new Image();
            img.onload = () => {
                // 3. Resolver la promesa con el objeto Image cargado
                resolve(img);
                URL.revokeObjectURL(imageUrl); // Liberar memoria
            };

            img.onerror = () => {
                reject(new Error("Error al cargar la imagen"));
                URL.revokeObjectURL(imageUrl); // Limpieza en caso de error
            };
            img.src = imageUrl;
        });
    }
    


    return(
        <>
            <BodyMain>
                <div style={{display:'flex', flexDirection:'row', alignContent:'center'}}>
                     <h2>
                        {
                            action === 'addalbum' 
                                ? t("addAlbumGeneral.titleAddAlbum")
                                : action==='addsong'
                                    ? t("addAlbumGeneral.titleAddSong")
                                    : action==='view'
                                        ? t("addAlbumGeneral.titleViewDetails")
                                        : action==='edit' && isAlbum
                                            ? t("addAlbumGeneral.titleEditAlbum")
                                            : action==='edit' && !isAlbum
                                                ? t("addAlbumGeneral.titleEditSong")
                                                : ''
                        }
                    </h2>
                </div>

                <div>
                    <Tabs
                        value={value2}
                        onChange={handleChange}
                        textColor="secondary"
                        indicatorColor="secondary"
                        aria-label="secondary tabs example"
                    >
                        <Tab value="one" label={t("addAlbumGeneral.titleTabInfo")}/>
                        <Tab value="two" label={t("addAlbumGeneral.titleTabArtist")}
                            disabled={(action==='addalbum' || action==='addsong') && readOnly } />
                        <Tab value="three" label={t("addAlbumGeneral.titleTabSong")}
                            disabled={(action==='addalbum' || action==='addsong') && readOnly } />
                    </Tabs>

                    {/* Contenido de cada pestaña */}
                    <TabPanel value={value2} index="one">
                        <div>
                            <form onSubmit={handleSubmit(onSubmit)}
                                style={{
                                    width:'100%',
                                    height:'100%',
                                    display:'flex',
                                    flexDirection:'column',
                                }}
                            >
                                <Grid container size={12} direction="row">
                                    <Grid size={4}>
                                        <div style={{display:'flex', flexDirection:'column', justifyContent:'center'}}>
                                            <img src={albumCoverImage}
                                                style={{ 
                                                    alignSelf: 'center',
                                                    borderRadius: '10px',
                                                    width: (deviceType==='minicell' || deviceType==='cell' || deviceType==='laptop' ? '95%' : '95%')
                                                }} 
                                            /> 
                                            <div style={{fontSize:10,color:'gray',width:'100%',textAlign:'center',marginTop:'5px'}}>
                                                {t("addAlbumGeneral.resolution")}
                                            </div>
                                            <br />
                                            <Button 
                                                component="label" 
                                                variant="text" 
                                                startIcon={<CloudUploadIcon />}
                                                sx={{ ...constants.styles.linkButton, 
                                                    fontSize: '11px', 
                                                    position: 'relative',
                                                    display: action==='view' ? 'none' : ''
                                                }}
                                                disabled={
                                                    (((action==='addalbum' || action==='addsong') && readOnly)
                                                    || (action==='view'))
                                                }
                                            >
                                                {
                                                    isAlbum ? t("addAlbumGeneral.changeImageAlbum") : t("addAlbumGeneral.changeImageSong")
                                                }
                                                <VisuallyHiddenInput
                                                    type="file"
                                                    onChange={(event) => uploadCoverFile(event)}
                                                    multiple={false}
                                                    accept=".png,.jpg,.jpeg"
                                                />
                                            </Button>

                                            <Button 
                                                component="label" 
                                                variant="text" 
                                                startIcon={<CloudDownloadIcon />}
                                                sx={{ ...constants.styles.linkButton, fontSize: '11px', position: 'relative',
                                                    display: albumCoverImage!==null && !albumCoverImage.includes('no-image', 0) ? '' : 'none',
                                                }}
                                                onClick={(e) => downloadFile(albumCoverImage, `imageAlbumFile.jpg`)}
                                            >
                                                {t("addAlbumGeneral.downloadImage")}
                                            </Button>
                                        </div>
                                    </Grid>
                                    <Grid size={8}>
                                        <TextField label={isAlbum ? t("addAlbumGeneral.albumTitle") : t("addAlbumGeneral.songTitle")} variant="outlined" margin="normal" autoFocus fullWidth 
                                            sx={{...constants.styles.textfield, marginBottom: '15px', display: isAlbum ? '' : 'none'}} 
                                            {...register('title')}
                                            error={!!errors.title}
                                            helperText={errors.title?.message}
                                        />

                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DatePicker']}>
                                                <Controller
                                                    name="launchingDate"
                                                    control={control}
                                                    render={({ field, fieldState: { error } }) => (
                                                        <DatePicker
                                                            label={t("addAlbumGeneral.launchingDate")}
                                                            format="DD/MM/YYYY"
                                                            value={field.value ? dayjs(field.value) : null}
                                                            onChange={(date) => field.onChange(date)}
                                                            slotProps={{
                                                                textField: {
                                                                error: !!error,
                                                                helperText: error?.message,
                                                                },
                                                            }}
                                                            sx={{ marginBottom: '15px' }}
                                                        />
                                                    )}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>

                                        <TextField label={t("addAlbumGeneral.creator")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px', marginTop: '15px'}} 
                                            {...register('creator')}
                                            error={!!errors.creator}
                                            helperText={errors.creator?.message}
                                        />
                                        <TextField label={t("addAlbumGeneral.producer")} variant="outlined" margin="normal" fullWidth sx={{...constants.styles.textfield, marginBottom: '15px'}} 
                                            {...register('producer')}
                                            error={!!errors.producer}
                                            helperText={errors.producer?.message}
                                        />
                                        <div style={{fontSize:10, alignContent:'center'}}>
                                            <Checkbox
                                                checked={(action==='edit' || action==='view') || checked}
                                                onChange={handleChange_Terms}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                                disabled={action==='view' || action==='edit' || 
                                                    ((action==='addalbum' || action==='addsong') && albumId>0)
                                                }
                                            />
                                            {t("addAlbumGeneral.checkTermsConditions")} <b style={{color:'blue'}}>
                                                {/* {t("addAlbumGeneral.linkTermsConditions")} */}
                                                <Button 
                                                    component="label" 
                                                    variant="text" 
                                                    sx={{ ...constants.styles.linkButton, fontSize: '11px', position: 'relative' }}
                                                    onClick={()=>handleClickTerms(true)}
                                                >
                                                    {t("footer.serviceTerms")}
                                                </Button>
                                            </b>
                                        </div>
                                    </Grid>
                                </Grid>
                                <div style={{display:'flex', marginTop:'35px'}}>
                                    <div style={{flex:1}} />
                                    <Button
                                        type="submit"
                                        variant="outlined"
                                        sx={{ ...constants.styles.mainButton, 
                                            width: '180px',
                                            display: action==='view' ? 'none' : 'block',
                                        }}
                                        disabled={
                                            (((action==='addalbum' || action==='addsong') && (readOnly && !checked))
                                            || (action==='view'))
                                        }
                                    >
                                        {
                                            isAlbum ? t("addAlbumGeneral.btnSaveAlbum") : t("addAlbumGeneral.btnSaveSong")
                                        }
                                    </Button>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        onClick={()=>handleReturnBack()}
                                        sx={{ ...constants.styles.secondaryButton, width: '180px', marginLeft:'10px'}}
                                    >
                                        {t("addAlbumGeneral.btnCancel")}
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </TabPanel>
                    <TabPanel value={value2} index="two">
                        <div>
                            <Button 
                                component="label" 
                                variant="text" 
                                startIcon={<AddIcon />}
                                sx={{ ...constants.styles.linkButton, fontSize: '11px', position: 'relative',
                                    display: action==='view' ? 'none' : '',
                                 }}
                                onClick={()=>handleClick_AddArtist()}
                            >
                                {t("addAlbumGeneral.addArtist")}
                            </Button>

                            <Box sx={{ 
                                width: '100%',
                                '& .alternateClass': {
                                    backgroundColor: '#f2f2f2',
                                    borderTop: '1px solid #e8e8e8',
                                },
                                '& .rowClass': {
                                    borderTop: '1px solid #e8e8e8',
                                },
                                '& .alternateClass:hover': {
                                    backgroundColor: '#999c9e',
                                },
                                '& .rowClass:hover': {
                                    backgroundColor: '#999c9e',
                                },
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <DataGrid
                                        getRowId={(row) => row.albumArtistId}
                                        getRowHeight={() => 40}
                                        rows={listArtist || []}
                                        columns={columnsArtist}
                                        paginationModel={{ page: 0, pageSize: 100 }} // Muestra todas las filas
                                        pageSizeOptions={[]} // Oculta el selector de páginas
                                        hideFooter
                                        getRowClassName ={
                                            (params) =>
                                                params.indexRelativeToCurrentPage % 2 === 0 ? 'alternateClass' : 'rowClass'
                                        }
                                        checkboxSelection = {false}
                                        disableRowSelectionOnClick
                                        disableColumnMenu
                                        localeText={
                                            language === 'es' 
                                            ? esES.components.MuiDataGrid.defaultProps.localeText
                                            : enUS.components.MuiDataGrid.defaultProps.localeText
                                        }
                                        sx={{
                                            '& .MuiDataGrid-cell, .MuiDataGrid-columnHeader': {
                                                color: '#667', 
                                                fontSize: '0.8rem',
                                            },
                                        }}
                                    />
                                </div>
                            </Box>
                            <div style={{display:'flex', marginTop:'35px'}}>
                                <div style={{flex:1}} />
                                <Button
                                    type="button"
                                    variant="outlined"
                                    onClick={()=>handleReturnBack()}
                                    sx={{ ...constants.styles.secondaryButton, width: '180px', marginLeft:'10px'}}
                                >
                                    {t("addAlbumGeneral.btnCancel")}
                                </Button>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel value={value2} index="three">
                        <div>
                            <Button 
                                component="label" 
                                variant="text" 
                                startIcon={<AddIcon />}
                                sx={{ ...constants.styles.linkButton, 
                                    fontSize: '11px', 
                                    position: 'relative',
                                    display: action==='view' || (!isAlbum && numSongs>0) ? 'none' : ''
                                }}
                                onClick={()=>setOpenAddSong(true)}
                            >
                                {t("addAlbumGeneral.addSong")}
                            </Button>

                            <Box sx={{ 
                                width: '100%',
                                '& .alternateClass': {
                                    backgroundColor: '#f2f2f2',
                                    borderTop: '1px solid #e8e8e8',
                                },
                                '& .rowClass': {
                                    borderTop: '1px solid #e8e8e8',
                                },
                                '& .alternateClass:hover': {
                                    backgroundColor: '#999c9e',
                                },
                                '& .rowClass:hover': {
                                    backgroundColor: '#999c9e',
                                },
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <DataGrid
                                        getRowId={(row) => row.albumSongId}
                                        getRowHeight={() => 60}
                                        rows={listSong || []}
                                        columns={columnsSongs}
                                        paginationModel={{ page: 0, pageSize: 100 }} // Muestra todas las filas
                                        pageSizeOptions={[]} // Oculta el selector de páginas
                                        hideFooter
                                        getRowClassName ={
                                            (params) =>
                                                params.indexRelativeToCurrentPage % 2 === 0 ? 'alternateClass' : 'rowClass'
                                        }
                                        checkboxSelection = {false}
                                        disableRowSelectionOnClick
                                        disableColumnMenu
                                        localeText={
                                            language === 'es' 
                                            ? esES.components.MuiDataGrid.defaultProps.localeText
                                            : enUS.components.MuiDataGrid.defaultProps.localeText
                                        }
                                        sx={{
                                            '& .MuiDataGrid-cell, .MuiDataGrid-columnHeader': {
                                                color: '#667', 
                                                fontSize: '0.8rem',
                                            },
                                        }}
                                    />
                                </div>
                            </Box>
                            <div style={{display:'flex', marginTop:'35px'}}>
                                <div style={{flex:1}} />
                                <Button
                                    type="button"
                                    variant="outlined"
                                    onClick={()=>handleReturnBack()}
                                    sx={{ ...constants.styles.secondaryButton, width: '180px', marginLeft:'10px'}}
                                >
                                    {t("addAlbumGeneral.btnCancel")}
                                </Button>
                            </div>
                        </div>
                    </TabPanel>
                </div>
            </BodyMain>

            <AddArtist albumId={albumId} albumArtistId={selectedAlbumArtist} 
                open={openAddArtist} onClose={handleClose_AddArtist} 
                maxPercentageAllowed={maxPercentageAllowed}
            />
            <AddSong albumId={albumId} 
                open={openAddSong} onClose={handleAddSong} />
            <Message title={t("addAlbumGeneral.messageTitle")} content={isAlbum ? t("addAlbumGeneral.messageContentAlbum") : t("addAlbumGeneral.messageContentSong")}
                open={showMessageSave} onClose={()=>setShowMessageSave(false)} />
            <Confirmation title={t("addAlbumGeneral.confirmTitle")} content={t("addAlbumGeneral.confirmContent")}
                open={showConfirmDeleteArtist} onClose={()=>setShowConfirmDeleteArtist(false)} 
                onResponse={handleDeleteArtist} />
            <Confirmation title={t("addAlbumGeneral.confirmTitle")} content={t("addAlbumGeneral.confirmContent")}
                open={showConfirmDeleteSong} onClose={()=>setShowConfirmDeleteSong(false)} 
                onResponse={handleDeleteSong} />
        </>
    );
}

export default AddAlbum;